module.exports = __webpack_public_path__ + "static/06-7611ddfc91fb440158abced492f44a8b.jpg";